<script setup lang="ts">
import { CheckCircle, XCircle, X } from 'lucide-vue-next'
import { useToast } from '@/composables/useToast'

const { toasts, dismiss } = useToast()
</script>

<template>
  <Teleport to="body">
    <div class="pointer-events-none fixed right-6 top-6 z-[2000] flex flex-col gap-s">
      <TransitionGroup
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="translate-x-8 opacity-0"
        enter-to-class="translate-x-0 opacity-100"
        leave-active-class="transition duration-200 ease-in"
        leave-from-class="translate-x-0 opacity-100"
        leave-to-class="translate-x-8 opacity-0"
      >
        <div
          v-for="toast in toasts"
          :key="toast.id"
          role="status"
          aria-live="polite"
          class="pointer-events-auto flex w-[400px] items-start gap-s rounded-m border p-m shadow-2"
          :class="
            toast.type === 'success'
              ? 'border-green-200 bg-green-50'
              : 'border-red-200 bg-red-50'
          "
        >
          <CheckCircle
            v-if="toast.type === 'success'"
            :size="20"
            class="mt-2xxs shrink-0 text-status-success"
            aria-hidden="true"
          />
          <XCircle
            v-else
            :size="20"
            class="mt-2xxs shrink-0 text-status-danger"
            aria-hidden="true"
          />

          <div class="flex flex-1 flex-col gap-2xxs">
            <p
              v-if="toast.title"
              class="text-body-small font-semibold"
              :class="toast.type === 'success' ? 'text-green-800' : 'text-red-800'"
            >
              {{ toast.title }}
            </p>
            <p
              class="text-body-small"
              :class="[
                toast.type === 'success' ? 'text-green-700' : 'text-red-700',
                !toast.title && 'font-medium',
              ]"
            >
              {{ toast.message }}
            </p>
          </div>

          <button
            type="button"
            aria-label="Dismiss notification"
            class="shrink-0 rounded p-2xxs transition-colors hover:bg-black/5"
            @click="dismiss(toast.id)"
          >
            <X
              :size="16"
              :class="toast.type === 'success' ? 'text-status-success' : 'text-status-danger'"
              aria-hidden="true"
            />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
